import { groups } from './groups';
import { databases } from './databases';

export const db = {
  namespaced: true,
  modules: {
    databases,
    groups
  }
};
